import * as FormHelpers from '../forms/helpers';
import * as Widget from './base';
import * as WidgetHelper from './helper';

function setup_trigger(config) {
  var banner = Widget.get(config);

  if (banner) {
    const close_buttons = banner.querySelectorAll('.driftrock-close');

    if (close_buttons.length > 0) {
      [...close_buttons].forEach((close_button) => {
        close_button.addEventListener('click', function (e) {
          hide(config);
        });
      });
    }

    const collapse_buttons = banner.querySelectorAll('.driftrock-bar-collapse')

    if (collapse_buttons.length > 0) {
      [...collapse_buttons].forEach((collapse_button) => {
        collapse_button.addEventListener('click', function (e) {
          toggle_content(config);
        });
      });
    }

    var trigger_buttons = banner.querySelectorAll('.driftrock-bar-collapsed__cta');

    if (trigger_buttons.length > 0) {
      [...trigger_buttons].forEach((expand_button) => {
        expand_button.addEventListener('click', function (e) {
          toggle_content(config)
        });
      });
    }
  }
}

function widget_content(config) {
  return Widget.get(config).querySelector(`.driftrock-bar__expanded`);
}

function is_widget_content_visible(config) {
  var banner_content = widget_content(config);

  if (banner_content) {
    return !banner_content.classList.contains('invisible')
  }
}

function sync_body_margin(config) {
  var banner = Widget.get(config);

  if (banner) {
    const body_has_banner = document.body.classList.contains(`driftrock-body-with-${config.widget.format_config.options.position}-bar`);

    /*
      body_has_banner = true && widget_visible = true -> margin = banner height
      body_has_banner = false && widget_visible = true -> margin = 0
    */

    if (body_has_banner && Widget.is_visible(config)) {
      var banner_header = banner.querySelector('.driftrock-bar__collapsed-container');
      const height = banner_header.getBoundingClientRect().height + 32;
      FormHelpers.setStyle(document.body, `margin-${config.widget.format_config.options.position}`, `${height}px`);
    } else if (!body_has_banner && is_widget_visible(config)) {
      FormHelpers.setStyle(document.body, `margin-${config.widget.format_config.options.position}`, `0px`);
    }
  }
}

export function show(config) {
  var banner = Widget.get(config);

  if (banner) {
    document.body.classList.add(`driftrock-body-with-${config.widget.format_config.options.position}-bar`)
    banner.classList.remove('invisible');

    sync_body_margin(config);

    FormHelpers.setStyle(banner, config.widget.format_config.options.position, `0px`);
  }
}

export function hide(config) {
  var banner = Widget.get(config);

  if (banner) {
    const height = banner.getBoundingClientRect().height;
    document.body.classList.remove(`driftrock-body-with-${config.widget.format_config.options.position}-bar`)

    sync_body_margin(config);
    FormHelpers.setStyle(banner, config.widget.format_config.options.position, `-${height}px`);
    setTimeout(() => banner.classList.add('invisible'), 500);
  }
}

export function toggle(config) {
  Widget.toggle(config);
}

export function show_content(config) {
  var banner = Widget.get(config);

  if (banner) {
    var banner_content = widget_content(config);

    banner_content.classList.remove('invisible');
    banner.classList.remove('driftrock-bar--collapsed');
    FormHelpers.setStyle(banner, 'max-height', '100%');
    WidgetHelper.sync_iframe_height(banner);
  }
}

export function hide_content(config) {
  var banner = Widget.get(config);

  if (banner) {
    var banner_content = widget_content(config);
    banner_content.classList.add('invisible');
    banner.classList.add('driftrock-bar--collapsed');
    FormHelpers.setStyle(banner, 'max-height', `auto`);
  }
}

export function toggle_content(config) {
  var banner = Widget.get(config);

  if (banner) {
    const height = banner.getBoundingClientRect().height;

    var banner_content = widget_content(config);
    if (is_widget_content_visible(config)) {
      hide_content(config)
    } else {
      show_content(config)
    }
  }
}

export function init(config) {
  if (Driftrock.settings.debug) {
    console.info(`[Driftrock] Initialising banner widget: ${config.widget.id}`);
  }

  if (config.widget_html) {
    document.body.insertAdjacentHTML('beforeend', config.widget_html)

    window.addEventListener('resize', function(event) {
      sync_body_margin(config);
    }, true);

    Widget.init_content(config);

    WidgetHelper.setup_open(config, show);

    setup_trigger(config);
  }
}
